(function(){
  function money(cents){ return '$' + (cents / 100).toFixed(2); }

  function initGallery(root){
    var track = root.querySelector('[data-gal-track]');
    if (!track || track.dataset.bound) return;
    track.dataset.bound = '1';
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
    var counter = root.querySelector('[data-gal-i]');
    function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function mark(){
      var i = current();
      if (counter) counter.textContent = i + 1;
      thumbs.forEach(function(t, n){ t.classList.toggle('is-on', n === i); });
    }
    var t;
    track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    thumbs.forEach(function(th, n){ th.addEventListener('click', function(){ go(n); }); });
    var prev = root.querySelector('[data-gal-prev]'), next = root.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function(){ go(current() - 1); });
    if (next) next.addEventListener('click', function(){ go(current() + 1); });
    root.swlGoToMedia = function(id){
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(id)) { go(i); return; }
      }
    };
  }

  function initPdp(root){
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    var dataEl = root.querySelector('[data-swl-product]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent).variants;
    var form = root.querySelector('[data-swl-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-swl-atc]');
    var btnLabel = form.querySelector('[data-swl-atc-label]');
    var err = form.querySelector('[data-swl-error]');
    var sticky = document.querySelector('[data-swl-sticky]');
    var stickyPrice = document.querySelector('[data-swl-sticky-price]');

    function selected(){
      var el = form.querySelector('input[name="swl-pack"]:checked');
      if (!el) return null;
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === el.value) return variants[i];
      return null;
    }
    function update(jump){
      form.querySelectorAll('[data-opt-card]').forEach(function(card){
        var inp = card.querySelector('input');
        card.classList.toggle('is-on', !!(inp && inp.checked));
      });
      var v = selected();
      if (!v) return;
      idInput.value = v.id;
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? 'Add to cart · ' + money(v.price) : 'Sold out';
      if (stickyPrice) stickyPrice.textContent = v.title + ' · ' + money(v.price);
      err.classList.remove('is-on');
      if (jump && v.featured_media && root.swlGoToMedia) root.swlGoToMedia(v.featured_media.id);
    }
    form.addEventListener('change', function(e){
      if (e.target && e.target.name === 'swl-pack') update(true);
    });
    update(false);

    document.querySelectorAll('[data-swl-pick-pack]').forEach(function(a){
      a.addEventListener('click', function(e){
        var title = a.getAttribute('data-swl-pick-pack');
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].title === title) {
            var inp = form.querySelector('input[name="swl-pack"][value="' + variants[i].id + '"]');
            if (inp) inp.checked = true;
            update(true);
            break;
          }
        }
        e.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){ sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(form);
      var go = sticky.querySelector('[data-swl-sticky-go]');
      if (go) go.addEventListener('click', function(e){ e.preventDefault(); form.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    form.addEventListener('submit', function(e){
      var v = selected();
      if (!v || !v.available) { e.preventDefault(); return; }
      idInput.value = v.id;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();
      var old = btnLabel.textContent;
      btn.disabled = true; btnLabel.textContent = 'Adding…';
      var sections = ['cart-drawer', 'cart-icon-bubble'];
      if (typeof drawer.getSectionsToRender === 'function') {
        try { sections = drawer.getSectionsToRender().map(function(s){ return s.id; }); } catch (x) {}
      }
      var fd = new FormData(form);
      fd.append('sections', sections.join(','));
      fd.append('sections_url', window.location.pathname);
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      fetch(addUrl + '.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data && data.status) { err.textContent = data.description || 'This could not be added. Please try again.'; err.classList.add('is-on'); return; }
          try { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
          catch (x) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'swl-pdp', cartData: data }); } catch (x) {} }
        })
        .catch(function(){ window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
        .finally(function(){ btn.disabled = false; btnLabel.textContent = old; });
    });
  }

  function init(){
    document.querySelectorAll('[data-swl-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-swl-pdp]').forEach(function(root){
      var gal = root.querySelector('[data-swl-gallery]');
      if (gal) root.swlGoToMedia = function(id){ if (gal.swlGoToMedia) gal.swlGoToMedia(id); };
      initPdp(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
